function Toggle() {
  return (
    <label className="toggle" htmlFor="toggle">
      <input type="checkbox" id="toggle" hidden />
    </label>
  );
}

export default Toggle;
